import { jsxs, jsx } from "react/jsx-runtime";
import { Icon } from "@zapier/zinnia-icons";
import atoms from "../../../styles/atoms.module.scss.js";
import { useHeaderContext } from "../Header.js";
import linkStyles from "./Link.module.scss.js";
function Link(props) {
  const context = useHeaderContext();
  return /* @__PURE__ */ jsxs(
    "a",
    {
      className: linkStyles.link,
      href: context.resolveURL(props.url),
      "aria-label": props.label,
      "data-testid": "nav-link",
      onClick: (e) => {
        context.emitLinkClickEvent(e, {
          interaction_name: "header_link_click",
          ...props.eventPayload
        });
      },
      ...props.openInNewTab && { target: "_blank", rel: "noreferrer" },
      children: [
        props.icon && /* @__PURE__ */ jsx("span", { className: atoms.flex, children: /* @__PURE__ */ jsx(Icon, { name: props.icon, size: 18 }) }),
        /* @__PURE__ */ jsx("span", { children: props.label })
      ]
    }
  );
}
export {
  Link
};
